<div class="grid-header" (click)="toggleState($event);" [ngClass]="{'active': isOpen, 'inactive': !isOpen, 'no-padding' : noPadding}">
    <ng-content></ng-content>
</div>